import axios from "@/hooks/axios/axios";
import { buildQueryParams } from "@/lib/buildQueryParams";

export interface QuadMediaParams {
  print_ids?: string[];
  online_news_ids?: string[];
  tv_ids?: string[];
  radio_ids?: string[];
  dateRange?: string;
  limit?: number;
  mode?: string;
  main_keywords?: string[];
  additional_keywords?: string[];
  excluded_keywords?: string[];
}

export async function getQuadMedia(
  params: QuadMediaParams,
  apiToken: string | null,
) {
  const base: Record<string, string | undefined> = {
    mode: params.mode,
    limit: params.limit !== undefined ? String(params.limit) : undefined,
    // dateRange is a flag key (e.g. "last_24_hours=true"), not a value
    ...(params.dateRange ? { [params.dateRange]: "true" } : {}),
  };

  const queryString = buildQueryParams(base, {
    main_keywords: params.main_keywords,
    additional_keywords: params.additional_keywords,
    excluded_keywords: params.excluded_keywords,
    print_ids: params.print_ids,
    online_news_ids: params.online_news_ids,
    tv_ids: params.tv_ids,
    radio_ids: params.radio_ids,
  });

  const { data } = await axios.get(`quadmedia?${queryString}`, {
    headers: { "x-api-token": apiToken || "" },
  });

  return data;
}
